// Copyright (c) Brock Allen & Dominick Baier. All rights reserved.
// Licensed under the Apache License, Version 2.0. See LICENSE in the project root for license information.

import { PopupWindow, type PopupWindowParams } from './PopupWindow';
import type { INavigator } from './INavigator';
import { Logger } from './Logger';

/**
 * @internal
 */
export class PopupNavigator implements INavigator {
  private readonly _logger = new Logger('PopupNavigator');

  public async prepare({ popupWindowFeatures, popupWindowTarget }: PopupWindowParams): Promise<PopupWindow> {
    return new PopupWindow({ popupWindowFeatures, popupWindowTarget });
  }

  public async callback(url: string, { keepOpen = false }): Promise<void> {
    this._logger.create('callback');

    PopupWindow.notifyOpener(url, keepOpen);
  }
}
